import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { PrefixComponent } from "../../prefix.component";
import { MapOptions, MarkerData, TemplateMapComponent } from "../../templates/template-map/template-map.component";

@Component({
  selector: "app-prefix-geo",
  imports: [TemplateMapComponent],
  templateUrl: "./prefix-geo.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-geo.component.less",
})
export class PrefixGeoComponent extends PrefixComponent<MarkerData[]> {
  @Input()
  public mode: TemplateMapComponent["mode"];

  public mapOptions: google.maps.MapOptions;
  public markerOptions: google.maps.marker.AdvancedMarkerElementOptions;

  public minlength: number;
  public maxlength: number;

  public options: MapOptions;

  public constructor() {
    super();
    this.mapOptions = {};
    this.markerOptions = {};
    this.minlength = 1;
    this.maxlength = 1;
    this.options = {};
    this.mode = "view";
  }
}
